import { render, staticRenderFns } from "./ImageForm.vue?vue&type=template&id=230b8186&scoped=true&"
import script from "./ImageForm.vue?vue&type=script&lang=ts&"
export * from "./ImageForm.vue?vue&type=script&lang=ts&"
import style0 from "./ImageForm.vue?vue&type=style&index=0&id=230b8186&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b8186",
  null
  
)

export default component.exports